import { UserService } from '@ospace/auth'
import { showNotification } from '@ospace/shared'
import { useMutation, useQueryClient } from 'react-query'

interface IProps {
  username: string
  status: boolean
}
export const useChangeUserStatus = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ username, status }: IProps) => {
      await UserService.changeUserStatus(username, status)
      return { username, status }
    },
    {
      onSuccess: ({ username, status }: IProps) => {
        showNotification({
          message: `The user was ${status ? 'enabled' : 'disabled'} successfully.`,
          type: 'success',
        })

        queryClient.setQueryData(['users'], (users: any) => {
          const user = users.find((d: any) => d.identityId === username)
          user.enabled = status
          return users
        })
      },
      onError: (e: any) => {
        showNotification({
          message: e.response?.data || e.message,
          type: 'error',
        })
      },
    }
  )
}
